import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { X, ShieldCheck, Download, Zap } from 'lucide-react';
export function Objections() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  const objections = ['Experiencia', 'Mucho dinero', 'Ser experta en tecnología'];
  return <section className="bg-brand-beige py-20 px-6" data-id="element-208">
      <div className="max-w-3xl mx-auto text-center" data-id="element-209">
        <FadeIn data-id="element-210">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-green mb-4" data-id="element-211">
            No necesitas experiencia previa.
          </h2>
          <p className="text-lg text-brand-text/70 mb-12" data-id="element-212">
            Este sistema está diseñado para principiantes que quieren empezar
            desde cero, con una guía clara y sin complicaciones.
          </p>
        </FadeIn>

        <div className="flex flex-col md:flex-row justify-center gap-6 mb-16" data-id="element-213">
          {objections.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-214">
              <div className="bg-white px-8 py-4 rounded-full shadow-sm flex items-center justify-center gap-3 border border-brand-green/5" data-id="element-215">
                <div className="bg-red-50 rounded-full p-1" data-id="element-216">
                  <X className="w-5 h-5 text-red-500" data-id="element-217" />
                </div>
                <span className="text-lg font-medium text-brand-text" data-id="element-218">
                  {item}
                </span>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-219">
          <p className="text-2xl font-serif text-brand-green mb-10 flex items-center justify-center gap-3" data-id="element-220">
            <span data-id="element-221">👉</span> Solo necesitas empezar con una guía clara
          </p>
          <Button onClick={goToCheckout} data-id="element-222">SÍ, QUIERO EMPEZAR</Button>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-223">
            <span className="flex items-center gap-1.5" data-id="element-224">
              <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-225" />
              ACCESO INMEDIATO
            </span>
            <span className="flex items-center gap-1.5" data-id="element-226">
              <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-227" />
              DESCARGA DIGITAL
            </span>
            <span className="flex items-center gap-1.5" data-id="element-228">
              <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-229" />
              COMPRA SEGURA
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}